import { useState } from "react";
import { toast } from "react-toastify";
import Handler from '../../Helpers/Handler'
import { reloadWindow } from '../../Helpers/Utils'

const PhoneNumber = ({ requestKey }) => {
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resendTimer, setResendTimer] = useState(120);
    const [canResend, setCanResend] = useState(false);
    const [data, setData] = useState({ number: "", otp: "" });
    const validateNumber = () => {
        const phoneRegex = /^[6-9]\d{9}$/;
        if (!data.number) {
            toast.error("Mobile number is required")
            return false;
        }
        if (!phoneRegex.test(data.number)) {
            toast.error("Enter a valid 10-digit mobile number")
            return false;
        }
        return true;
    };
    const validateOtp = () => {
        const otpRegex = /^\d{6}$/;
        if (!data.otp) {
            toast.error("OTP is required")
            return false;
        }
        if (!otpRegex.test(data.otp)) {
            toast.error("OTP must be 6 digits")
            return false;
        }
        return true;
    };

    const sendOtp = async () => {
        if (!validateNumber()) return;
        setLoading(true);
        const response = await Handler({ method: 'PATCH', url: `/customer/phone/${requestKey}/send-otp`, data: { phone: data.number } })
        setLoading(false);
        if (response?.success) {
            setOtpSent(true);
            toast.success("OTP sent successfully")
            setOtpSent(true);
            setCanResend(false);
            setResendTimer(120);

            const interval = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } else {
            toast.error(response?.message || "Failed to send OTP")
        }
    };

    const verifyOtp = async () => {
        if (!validateNumber() || !validateOtp()) return;
        setLoading(true);
        const response = await Handler({ method: 'PATCH', url: `/customer/phone/${requestKey}/verify-otp`, data: { phone: data.number, otp: data.otp } })
        if (response?.success) {
            toast.success("Mobile number verified successfully")
            setTimeout(() => {
                reloadWindow()
                setLoading(false);
            }, 2000);
        } else {
            toast.error(response?.message || "Invalid OTP")
            setLoading(false);
        }
    };

    return (
        <>
            <div className="mb-3">
                <label className="form-label">
                    Mobile Number
                </label>
                <input
                    type="tel"
                    maxLength={10}
                    className={`form-control`}
                    value={data.number}
                    onChange={(e) =>
                        setData((prev) => ({ ...prev, number: e.target.value.replace(/\D/g, "") }))
                    }
                    placeholder="Enter mobile number"
                />
            </div>

            {!otpSent ? (
                <div className="text-center " >
                    <button
                        className="btn btn-primary"
                        onClick={sendOtp}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send OTP"}
                    </button>
                </div>
            ) : (
                <>
                    <div className="mb-3">
                        <label className="form-label">
                            OTP
                        </label>

                        <input
                            type="text"
                            maxLength={6}
                            className={`form-control `}
                            value={data.otp}
                            onChange={(e) =>
                                setData((prev) => ({
                                    ...prev,
                                    otp: e.target.value.replace(/\D/g, "")
                                }))
                            }
                            placeholder="Enter OTP"
                        />
                    </div>
                    <div className="d-flex justify-content-end">
                        <button
                            className="fs-7 btn btn-link"
                            onClick={sendOtp}
                            disabled={loading || !canResend}
                        >
                            {canResend ? "Resend OTP" : `Resend in ${resendTimer}s`}
                        </button>
                    </div>
                    <div className="text-center">
                        <button
                            className="btn btn-success"
                            onClick={verifyOtp}
                            disabled={loading}
                        >
                            {loading ? "Verifying..." : "Verify OTP"}
                        </button>


                    </div>
                </>
            )}
        </>
    );
};

export default PhoneNumber;